<template>
    <div>
        <b-button
            variant="success"
            @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Metas
            </span>
        </b-button>
        <meta-form
            :mostrarModal="mostrarModal"
            :erros="erros"
            :evento="evento"
            @fechar="fecharModal()"
            @salvar="inserirMeta($event)"
            @atualizarLista="$emit('atualizarLista')"
        ></meta-form>
    </div>
</template>

<script>
import MetaForm from './MetaForm'
import EventosServicos from '../EventosServicos'

export default {
    props: {
        evento: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        MetaForm
    },
    
    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },
    },
}
</script>
